const Signup = (app) => {
  app
    .get("/signup", ({ res }) => {
      // legacy athlete/client signup is no longer supported (sc-45315)
      return res.redirect("/signup-coach");
    })
    .get(
      "/resend-verification/:email",
      async ({ req: { params }, res, api, flash, assert, login }) => {
        const { token, email, userId } = await (
          await api("register", {
            method: "POST",
            body: {
              email: params.email,
              resend: true,
            },
          })
        ).json();
        login({ _id: userId, token, email });
        flash("success", "Successfully resent email verification");
        res.redirect("/setup/step1");
      }
    );
};

export default Signup;
